/**
 * @returns {boolean}
 */

import dayjs from "dayjs";

export const isToday = ({
  year,
  month,
  date,
}: {
  year: number;
  month: number;
  date: number;
}): boolean => {
  const today = new Date();

  if (year !== today.getFullYear()) return false;
  if (month !== today.getMonth() + 1) return false;
  if (date !== today.getDate()) return false;

  return true;
};

/**
 * @description 해당 날짜가 선택한 날짜와 같은지 체크해주는 함수
 *
 * @param dateA 비교 대상 날짜
 * @param dateB 선택한 날짜
 */
export function isSameDate(dateA: Date, dateB: Date): boolean {
  if (!dateB) return false;

  return (
    dateA.getFullYear() === dateB.getFullYear() &&
    dateA.getMonth() === dateB.getMonth() &&
    dateA.getDate() === dateB.getDate()
  );
}

/**
 * Checks if a date is between two dates.
 * @param {Date | string | number} dateToCheck - The date to check.
 * @param {Date | string | number} startDate - The start date of the range.
 * @param {Date | string | number} endDate - The end date of the range.
 * @returns {boolean} - True if the date is between the start and end dates, inclusive.
 */
export function isDateBetween(
  dateToCheck: Date,
  startDate: Date,
  endDate: Date,
) {
  const date = dayjs(dateToCheck);
  const start = dayjs(startDate);
  const end = dayjs(endDate);

  return (
    (date.isAfter(start, "day") && date.isBefore(end, "day")) ||
    date.isSame(start, "day") ||
    date.isSame(end, "day")
  );
}

/**
 * @description 시작일부터 종료일까지의 평일(주말 제외) 계산 함수
 */
export function countBusinessDaysInRange(
  startDate: string | Date,
  endDate: string | Date,
  holidays?: string[],
) {
  const start = dayjs(startDate);
  const end = dayjs(endDate);
  const holidayList = holidays || [];

  if (!start.isValid() || !end.isValid() || start.isAfter(end)) {
    return 0;
  }

  let businessDays = 0;
  let current = start;

  while (!current.isAfter(end, "day")) {
    // 주말이 아닌 경우 (토요일: 0, 일요일: 6)
    if (
      current.day() !== 0 &&
      current.day() !== 6 &&
      !holidayList.includes(current.format("YYYY-MM-DD"))
    ) {
      businessDays++;
    }
    current = current.add(1, "day");
  }

  return businessDays;
}
